exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-progress-circle{\n  width: -webkit-fit-content !important;\n  width: fit-content !important;\n  width: -moz-fit-content !important;\n}\n.track-scrubbing > div{\n  padding: 0 !important;\n}\n.pctrl{\n  background: rgba(51, 51, 51, 0.85);\n  border: solid 1px rgba(51, 51, 51, .4) ;\n}\n.play-controls{\n  background: linear-gradient(to bottom right, rgba(255, 255, 255, 0.2), rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0.2));\n}\nh3{\n  font-size: 24px;\n  font-family: \"Berlin Sans FB\";\n  font-weight: 800;\n}\n.disabled{\n  pointer-events: none;\n  opacity: 0.5;\n}\n", ""]);

// exports
